import { signUpConfidantValidation } from "../../../redux/pis";

export const userConfidantValidation = (data) => async (dispatch) => {
  const { payload } = await dispatch(signUpConfidantValidation(data));
  if (payload.response && payload.response.error)
    return { error: payload.response.error };
  return payload;
};
